"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "TimeAndDate___StyledSvg",
  componentId: "sqmset-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function TimeAndDate(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M64.125 337.125V166.5H371.25v-51.188c0-18.802-15.305-34.124-34.125-34.124h-17.063V30h-34.125v85.313h-17.062V81.186H149.437V30h-34.125v85.313H98.25V81.186H64.125C45.305 81.188 30 96.493 30 115.314v221.812c0 18.82 15.305 34.125 34.125 34.125H166.5v-34.125H64.125z",
    style: {
      mixBlendMode: "darken"
    }
  }), _react["default"].createElement("path", {
    d: "M331.875 450c-65.137 0-118.125-52.988-118.125-118.125S266.738 213.75 331.875 213.75 450 266.738 450 331.875 397.012 450 331.875 450zm0-202.5c-46.524 0-84.375 37.85-84.375 84.375 0 46.524 37.85 84.375 84.375 84.375 46.524 0 84.375-37.85 84.375-84.375 0-46.524-37.85-84.375-84.375-84.375z",
    style: {
      mixBlendMode: "darken"
    }
  }), _react["default"].createElement("path", {
    style: {
      mixBlendMode: "darken"
    },
    d: "M397.5 345h-78.75v-78.75h39.375v47.25H397.5z"
  })));
}

var _default = TimeAndDate;
exports["default"] = _default;